export default __webpack_public_path__ + "static/media/buildhover.3fddf2aa.png";